export enum GeoLocationJSPathIdentifier {
    GEOCOMPLYJS = 'pathIdentifier=geocomplyjs',
    OOBEEJS = 'pathIdentifier=oobeejs',
    APPINTEGRATIONJS = 'pathIdentifier=appintegrationjs',
}

export enum GeoLocationWindowProp {
    GEOCOMPLY = 'GeoComply',
    GCOOBEE = 'GCOobee',
    GEOLOCATIONCOORDINATOR = 'geolocationCoordinator',
}

export type GeoLocationScriptMap = {
    identifier: GeoLocationJSPathIdentifier;
    windowProp: GeoLocationWindowProp;
};
